<template>
<ItpFormSelect2
  :name="name || path"
  v-model="item[path]"
  :options="options"
  valueField="id"
  textField="id"
  :readonly="readonly"
  :bindObject="bindObject"
  @input="evh_7315092382398562_input($event, {})"
>
</ItpFormSelect2>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class TaxCodeSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    required: true,
    type: String,
  })
  path!: string;

  @Watch('path')
  onPath(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("path")
  }

  @Prop({
    type: String,
  })
  name!: string;

  @Watch('name')
  onName(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("name")
  }

  @Prop({
    type: String,
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  @Prop({
    type: Boolean,
  })
  bindObject!: boolean;

  @Watch('bindObject')
  onBind_object(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("bindObject")
  }

  options!: any;

  async $$load_options() {
    return this.$app.repo.get('list_tax_code')
  }

  ux!: any;
  dataMembers = ['options', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        options: null,
        ux: null,
      },
    }
  }

  async act_7315092382398562_emit_7670_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_7315092382398562_emit_7670, alias=undefined
    return {
      event: "input",
      value: $event,
    }
  }

  async evh_7315092382398562_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_emit_7670: actions.EmitAction;
    evh_7315092382398562_input_7669: actions.EventHandlerImpl;
    evh_7315092382398562_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_emit_7670 = new actions.EmitAction(
      {
        actionArgs: this.act_7315092382398562_emit_7670_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_input_7669 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_emit_7670,
        event: "input",
        displayName: "emit",
      }
    );
    const evh_7315092382398562_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_input_7669],
      }
    );
    return {
      act_7315092382398562_emit_7670,
      evh_7315092382398562_input_7669,
      evh_7315092382398562_input,
    }
  }
}

Vue.component("TaxCodeSelector", TaxCodeSelector);

</script>